<template>
  <a-flex vertical gap="middle">
    <a-typography-text class="create-req-title">
      Создать новое обращение
    </a-typography-text>

    <a-input
      placeholder="Введите тему обращения"
      show-count
      :maxlength="60"
      v-model:value="theme"
    >
      <template #prefix> Тема: </template>
    </a-input>

    <SupportMessageInput
      :isSendButtonDisabled="isSendButtonDisabled"
      :sendButtonTooltip="sendTooltip"
      @send="sendClicked"
      v-model:value="message"
      v-model:decodedAttachments="decodedAttachments"
    ></SupportMessageInput>
  </a-flex>
</template>

<script setup lang="ts">
import SupportMessageInput from "@/components/settings/support/SupportMessageInput.vue";
import { computed, ref } from "vue";
import { useSupportUserStore } from "@/stores/support/support-user.store";
import router from "@/router";
import type { BlobImageDto } from "@/api/api.dto";
import { useChatStore } from "@/stores/chat/chat.store";

const supportStore = useSupportUserStore();
const chatStore = useChatStore();

const message = ref<string>("");
const theme = ref<string>("");
const decodedAttachments = ref<BlobImageDto[]>([]);

const isTextSmall = computed(
  () => theme.value.length < 5 || message.value.length < 5,
);

const sendTooltip = computed(() =>
  isTextSmall.value
    ? "Минимальная длина сообщения и темы 5 символов"
    : "Отправить сообщение",
);

const isSendButtonDisabled = computed(
  () => isTextSmall.value && !decodedAttachments.value?.length,
);

const sendClicked = async () => {
  if (isSendButtonDisabled.value) return;

  const firstMedia = decodedAttachments.value.at(0);
  const restMedia = firstMedia ? decodedAttachments.value.slice(1) : [];

  // Create a new chat and send the first message
  const chatId = await supportStore.sendFirstMessage({
    chatTitle: theme.value,
    message: message.value || null,
    image: firstMedia,
  });

  if (chatId) {
    for (const media of restMedia) {
      await chatStore.addMessageToChatWS({
        message: null,
        chatId,
        image: media,
      });
    }
    // Navigate to the newly created chat
    await router.push({
      name: "supportUserRequestSingle",
      params: { supportRequestId: chatId.toString() },
    });

    await chatStore.getCurrentRequest(chatId);
  }
};
</script>

<style scoped lang="scss">
.create-req-title {
  font-size: 15px;
}
</style>
